import { Container, Grid, makeStyles } from "@material-ui/core";
import React from "react";
import MenuBar from "../../layouts/dashboard/MenuBar";
import BoardsListSimple from "./collection/ListSimple";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(10),
    marginBottom: 100,
  },
}));

export default function Boards( props ) {

  const classes = useStyles();

  return (
    <React.Fragment>  
      <MenuBar/>
      <Container component="main" maxWidth="md">
        <Grid container className={classes.paper} >
          <Grid item xs={12}>
            <BoardsListSimple/>
          </Grid>
        </Grid>
      </Container>
    </React.Fragment>
  );

};
